export const notificationLabels = {
  like: '赞了你的帖子', comment: '评论了你的帖子', reply: '回复了你的评论', activity_completed: '已完成活动',
  recruitment_approved: '同意了你的申请', recruitment_rejected: '拒绝了你的申请',
  recruitment_withdrawn: '撤回了申请', recruitment_reapplied: '重新提交了申请', participation_confirmed: '已确认完成活动',
};
export const isApplicationNotification = item => ['recruitment_approved', 'recruitment_rejected', 'recruitment_withdrawn', 'recruitment_reapplied', 'participation_confirmed'].includes(item.kind);
export const notificationTarget = item => {
  const params = new URLSearchParams({ notification: String(item.id) });
  if (isApplicationNotification(item)) {
    if (!item.application_id) return null;
    if (['recruitment_approved', 'recruitment_rejected'].includes(item.kind)) return `/personal/applications/${item.application_id}?${params}`;
    params.set('application', item.application_id);
    return `/posts/${item.post_id}/manage?${params}`;
  }
  if (item.comment_id) params.set('comment', item.comment_id);
  return `/posts/${item.post_id}?${params}`;
};
